'use strict';/* global define */define('modules/dispatcher/values/events/index',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Definition of the available events
   *
   *
   * How it works:
   *
   * $scope.on( [Event Name], function( param_1, param_2 ) {
   * 	// Do something memorable here ;)
   * } );
   *
   */module.exports={/**
     * Update the list of the user's tasks
     *
     * @type {String} - Event name
     */UPDATE_TASKS:'UPDATE_TASKS',/**
     * Update the user feedback period config
     *
     * @type {String} - Event name
     */UPDATE_FEEDBACK_CONFIG:'UPDATE_FEEDBACK_CONFIG',/**
     * Update the requests and invitations on the dashboard
     * ( training, team, supervisor, 360 )
     *
     * @type {String} - Event name
     */UPDATE_NOTIFICATIONS:'UPDATE_NOTIFICATIONS',/**
     * Close the tasks bar
     *
     * @type {String} - Event name
     */CLOSE_TASKS:'CLOSE_TASKS',/**
     * Update goals for period
     *
     * @type {String} - Event name
     */UPDATE_GOALS_FOR_PERIOD:'UPDATE_GOALS_FOR_PERIOD',/**
     * Update feedback profile card once a meeting is scheduled
     *
     * @type {String} - Event name
     */UPDATE_MEETING_FOR_PERIOD:'UPDATE_MEETING_FOR_PERIOD',/**
     * Update supervisee feedback state
     *
     * @type {String} - Event name
     */UPDATE_SE_FEEDBACK_STATE:'UPDATE_SE_FEEDBACK_STATE',/**
     * Update language settings
     *
     * @type {String} - Event name
     */UPDATE_LANGUAGE_SETTINGS:'UPDATE_LANGUAGE_SETTINGS',/**
     * Update feedback met
     *
     * @type {String} - Event name
     */UPDATE_FEEDBACK_MET:'UPDATE_FEEDBACK_MET'};});
